import Profile from './components/Profile.vue'
import UserProfile from './components/UserProfile.vue'

export default [
  {
    path: '/user', component: Profile,
    children: [
      {path: 'profile', component: UserProfile, name: 'UserProfile'}
    ]
  },
]




// WEBPACK FOOTER //
// ./src/app/user/routes.js